export default "__VITE_ASSET__gV0JVhvBDfrQsRvHxCau5Q__";